import storage from '../../../../../../../hooks/useStorage/useStorage';

export class OfflineImageCacheManager {
  private constructor(private cache: Cache) {}

  static async create() {
    const teamId = storage.getTeamId();

    if (!teamId || !('caches' in window)) {
      return null;
    }

    const cache = await caches.open(this.getCacheKey(teamId));
    return new OfflineImageCacheManager(cache);
  }

  static async createForServiceWorker(teamId: string) {
    const cache = await caches.open(this.getCacheKey(teamId));
    return new OfflineImageCacheManager(cache);
  }

  getCache(url: string) {
    return this.cache.match(url);
  }

  cacheResponse(url: string, response: Response) {
    return this.cache.put(url, response);
  }

  async removeAll() {
    const allKeys = await this.cache.keys();
    await Promise.all(allKeys.map((key) => this.cache.delete(key)));
  }

  static getCacheKey(teamId: string) {
    return `offline-products-image-cache-${teamId}-v1`;
  }
}
